import { useCallback, useEffect, useState } from 'react';
import ApiDatabase from 'server';

/** Reads the event history of one time sheet. A failure here must never break
 *  the sheet itself: the history is a diagnostic aid, not page content. */
const useTimeSheetHistory = (timeSheetId) => {
  const [events, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    if (!timeSheetId) return;
    setIsLoading(true);
    setError(null);
    ApiDatabase.getTimeSheetHistory(
      { id: timeSheetId },
      (data) => {
        setEvents(data?.events || []);
        setCount(data?.count || 0);
        setIsLoading(false);
      },
      () => {
        setEvents([]);
        setCount(0);
        setError(true);
        setIsLoading(false);
      }
    );
  }, [timeSheetId]);

  useEffect(() => {
    load();
  }, [load]);

  return { events, count, isLoading, error, reload: load };
};

export default useTimeSheetHistory;
